// eslint-disable-next-line no-shadow
enum ButtonType {
    OUTLINED = 'outlined',
    OUTLINED_PRIMARY = 'outlined-primary',
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
    NEGATIVE_OUTLINED = 'negative-outlined',
    ICON_ONLY = 'icon-only',
    ICON_ONLY_OUTLINED = 'icon-only-outlined',
    VERTICAL_OUTLINED = 'verticle-outlined',
    WITHOUT_OUTLINE = 'without-outline',
    PRIMARY_WITHOUT_OUTLINE = 'primary-without-outline'
}

export default ButtonType;
